import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const cardItem = [
    {
      image:
        "	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/image80781_IMG.jpg",
      title: "TNPSC APPTITUDE & LANGUAGE",
      amount: 499,
      points: [
        "Total Question: 30",
        "Syllabus: General English/Tamil and Aptitude",
        "Registration Fee : ₹499/-",
      ],
      detailsLink: "https://vidhvaa.com/scheduled-exam-2026",
      payLink:
        "http://vidhvaa.com/register-link?planCode=PLA202603D147&appType=careermate",
    },
    // {
    //   image:
    //     "	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/image13453_IMG.jpg",
    //   title: "CURRENT AFFAIRS",
    //   amount: 100,
    //   points: [
    //     "Total Question: 30",
    //     "Syllabus: Current Affairs - March 2026",
    //     "Registration Fee : ₹100/-",
    //   ],
    //   detailsLink: "https://vidhvaa.com/current-affairs-mar-2026",
    //   payLink:
    //     "http://dev.vidhvaa.com/register-link?planCode=PLA202603D146&appType=careermate",
    // },
    {
      image:
        "	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/image44661_IMG.jpg",
      title: "LABOUR DAY",
      amount: 200,
      points: [
        "Total Question: 30",
        "Syllabus: Workers’ Rights & Laws",
        "Registration Fee : ₹200/-",
      ],
      detailsLink: "https://vidhvaa.com/labourday-2026",
      payLink:
        "http://vidhvaa.com/register-link?planCode=PLA202603D148&appType=careermate",
    },
  ];

  return (
    <div>
      {/* HEADER */}
      <div className="bg-dark text-center py-2">
        <img
          src="https://d242nlqul83u9g.cloudfront.net/WEB/common/white_hdr_logo.png"
          className="img-fluid"
          style={{ height: "50px" }}
          alt="logo"
        />
      </div>

      <div className="container">
        <h1 className="text-center my-3" style={{ color: "#FFAF01" }}>
          CURRENT PACKAGES
        </h1>

        {/* CARDS */}
        <div className="row g-4">
          {cardItem.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <Card className="shadow-lg border-0 h-100 rounded-4 overflow-hidden">
                {/* IMAGE */}
                <Card.Img src={item.image} />

                <Card.Body className="d-flex flex-column">
                  {/* BUTTONS */}
                  <div className="d-flex gap-4">
                    {/* MORE DETAILS → LANDING */}
                    <Button
                      as={Link}
                      to={item.detailsLink}
                      variant="outline-dark"
                      className="w-50 fw-semibold border-0"
                      style={{
                        backgroundColor: "#FFAF01",
                        borderRadius: "15px",
                      }}
                    >
                      More Details
                    </Button>

                    {/* PAY NOW → REGISTER */}
                    <Button
                      as={Link}
                      to={item.payLink}
                      className="w-50 border-0 fw-semibold"
                      style={{
                        backgroundColor: "#c0beba",
                        borderRadius: "15px",
                        color: "black",
                      }}
                    >
                      {/* ₹{item.amount} /- */}
                      Pay Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>

        {/* ASK TO EXPERT SECTION */}
        <div className=" mt-3 my-5 text-center">
          <Link to="/ask-expert" className="text-decoration-none">
            <div className=" bg-light rounded-4 shadow-sm hover-shadow">
              <h4
                className="p-2 fw-semibold"
                style={{
                  backgroundColor: "#FFAF01",
                  borderRadius: "10px",
                  color: "black",
                }}
              >
                Ask To Expert
              </h4>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
